import { typingStatus, updateConversationMessage, updateMessageUnreadCount, updateRecentChatMessage } from "./Components/WebChat/Common/createMessage";
import { store } from "./Redux/store";
import uuidv4 from "uuid/v4";
import { addRecentChat, clearLastMessageinRecentChat, deleteMessageinRecentChat, recentRecallUpdate, recentRemoveMessageUpdate, updateMuteStatusRecentChat, updateRecentChatMessageStatus, updateRecentMsgByLastMsgId } from "./Redux/feature/recentChatDataSlice"
import { clearChatHistoryAction, deleteChatHistoryAction, deleteMessageForEveryone, deleteMessageForMe, UpdateChatConversationHistory } from "./Redux/feature/chatConversationHistorySlice";
import { CONNECTION_STATE_CONNECTING, GROUP_PROFILE_INFO_UPDATED, GROUP_USER_ADDED, GROUP_USER_LEFT, GROUP_USER_MADE_ADMIN, GROUP_USER_REMOVED, MSG_CLEAR_CHAT, MSG_CLEAR_CHAT_CARBON, MSG_DELETE_CHAT, MSG_DELETE_CHAT_CARBON, MSG_DELETE_STATUS, MSG_DELETE_STATUS_CARBON, MSG_DELIVERED_STATUS, MSG_DELIVERED_STATUS_CARBON, MSG_DELIVERED_STATUS_ID, MSG_SEEN_STATUS_ID } from "./Helpers/Chat/Constant";
import { getGroupData, setGroupParticipants, setGroupParticipantsByGroupId } from "./Helpers/Chat/Group";
import { formatUserIdToJid, getActiveConversationChatId, isActiveConversationUserOrGroup, messageInfoAction } from "./Helpers/Chat/ChatHelper";
import SDK from "./SDK";
import { addPresenceData } from "./Redux/feature/presenceDataSlice";
import { updateconnStatus } from "./Redux/feature/connectionStatusSlice";
import { deleteItemFromLocalStorage, encryptAndStoreInLocalStorage, getFromLocalStorageAndDecrypt } from "./Helpers/Chat/webChatEncryptDecrypt";
import { setConnectionStatus } from "./Components/WebChat/Common/FileUploadValidation";
import { handleBlockMethods, reconnect } from "./Helpers/Reconnect";
import { updateMediaUploadStateData } from "./Redux/feature/updateMediaUploadDataSlice";
import { addGroupsData, updateGroupsData } from "./Redux/feature/groupsDataSlice";
import { addReplyMessageData } from "./Redux/feature/replyMessageDataSlice";
import { clearMissedCallNotificationTimer, dispatchDisconnected, handleCallParticipantToast, startCallingTimer, updateCallTypeAfterCallSwitch } from "./Helpers/Call/Call";
import { addCallConnectionDate, largeVideoUserReducer } from "./Redux/feature/callConnectionDateSlice";
import { getLocalUserDetails, getUserDetails, isLocalUser, isSingleChatJID } from "./Helpers/Chat/User";
import { addShowConfrenceData, resetConferenceData } from "./Redux/feature/showConfrenceDataSlice";
import { addVCardData } from "./Redux/feature/userDataSlice";
import { addMessageInfoUpdate } from "./Redux/feature/messageInfoDataSlice";
import { addCallConversion } from "./Redux/feature/callConversionDataSlice";
import { hideModal,showModal } from "./Redux/feature/popUpDataSlice";
import { toast } from "react-toastify";
import { CALL_BUSY_STATUS_MESSAGE, CALL_CONVERSION_STATUS_CANCEL, CALL_CONVERSION_STATUS_DECLINE, CALL_CONVERSION_STATUS_REQ_WAITING, CALL_ENGAGED_STATUS_MESSAGE, CALL_STATUS_CONNECTED, CALL_STATUS_ENDED, CALL_STATUS_RECONNECT, CALL_TYPE_AUDIO, CALL_TYPE_VIDEO, DISCONNECTED_SCREEN_DURATION } from "./Helpers/Call/Constant";
import { rosterUpdate } from "./Redux/feature/rosterDataSlice";
import { constructMute, logout, removeDuplicates } from "./Helpers/Utility";
import { callDurationTimestamp } from "./Redux/feature/callDurationDataSlice";
import browserNotify from "./Helpers/Browser/BrowserNotify";
import callLogs from "./Components/WebCall/CallLogs/callLog";
import { addIsMuteListner } from "./Redux/feature/calllogsDataSlice";
import { addActiveChatData, resetActiveChatData, updateMuteStatusActiveChat } from "./Redux/feature/activeChatDataSlice";
import { messageData } from "./Redux/feature/messageDataSlice";
import { unreadCountConstruction } from "./initial";
import { updateBlockedContactAction, updateContactWhoBlockedMeAction } from "./Components/WebChat/ConversationSection/PopUp/BlockAction";
import { addAdminBlock } from "./Redux/feature/adminBlockUserSlice";
import { addCallIntermediate, resetCallIntermediate } from "./Redux/feature/callIntermediateScreenSlice";

export let strophe = false;
let localStream = null,
    localVideoMuted = false,
    localAudioMuted = false,
    onCall = false;
let remoteStream = [],
    newRemoteVideoMuted = {},
    newRemoteAudioMuted = {};

const localstoreCommon = () => {
    encryptAndStoreInLocalStorage('callingComponent', false)
    deleteItemFromLocalStorage('roomName');
    deleteItemFromLocalStorage('callType');
    deleteItemFromLocalStorage('call_connection_status');
    encryptAndStoreInLocalStorage("hideCallScreen", false);
};
   
const dispatchCommon = () => {
    store.dispatch(addShowConfrenceData({
        callStatusText: null,
        showComponent: false,
        showStreamingComponent: false,
        stopSound: true,
        showCalleComponent: false
    }));
    store.dispatch(addCallConversion());
    store.dispatch(hideModal());
    resetCallData();
};

const updateStoreRemoteStream = () => {
    const {
        getState
    } = store;
    const {
        data = {}
    } = getState().showConfrenceData;
    store.dispatch(addShowConfrenceData({
        ...data,
        remoteStream
    }));
}

export const muteLocalVideo = (isMuted) => {
    localVideoMuted = isMuted;
    let vcardData = getLocalUserDetails();
    let currentUser = vcardData.fromUser;
    currentUser = formatUserIdToJid(currentUser)
    newRemoteVideoMuted = constructMute(newRemoteVideoMuted,currentUser,isMuted)
};

export const muteLocalAudio = (isMuted) => {
    localAudioMuted = isMuted;
    let vcardData = getLocalUserDetails();
    let currentUser = vcardData.fromUser;
    currentUser = formatUserIdToJid(currentUser)
    newRemoteAudioMuted = constructMute(newRemoteAudioMuted,currentUser,isMuted)
};


export const removeRemoteStream = (userJid) => {
    let localRemoveRemoteStream =  [...remoteStream]
    remoteStream.forEach((item, key) => {
        if (item.fromJid === userJid) {
            localRemoveRemoteStream.splice(key, 1);
        }
    });
    remoteStream = [...localRemoveRemoteStream]

}

export const getRemoteStream = () => remoteStream;

export const resetCallData = () => {
    onCall = false;
    remoteStream = [];
    localStream = null;
    newRemoteVideoMuted = {};
    newRemoteAudioMuted = {};

    localVideoMuted = false;
    localAudioMuted = false;
    if (getFromLocalStorageAndDecrypt("isNewCallExist") === true) {
        deleteItemFromLocalStorage("isNewCallExist")
    }
    else {
        store.dispatch(resetCallIntermediate());
    }
    store.dispatch(callDurationTimestamp());
    store.dispatch(resetConferenceData());
    /**
     * resetData();
     */    
    setTimeout(() => {
        store.dispatch(addIsMuteListner(false));
    }, 1000)
};

const subscribed = (res) => {
    const {
        getState,
        dispatch
    } = store;
    const showConfrenceData = getState().showConfrenceData;
    const {
        data
    } = showConfrenceData;
    dispatch(addShowConfrenceData({
        ...(data || {}),
        localVideoMuted: data.mediaError ? localVideoMuted : false,
        localStream: localStream,
        remoteStream,
        localAudioMuted: localAudioMuted,
        status: "SUBSCRIBED"
    }));
}

const callStatus = (res) => {
    if (res.status === "ringing") {
        ringing(res);
    } else if (res.status === "connecting") {
        connecting(res);
    } else if (res.status === "connected") {
        connected(res);
    } else if (res.status === "busy") {
        handleEngagedOrBusyStatus(res);
    } else if (res.status === "disconnected") {
        disconnected(res);
    } else if (res.status === "engaged") {
        handleEngagedOrBusyStatus(res);
    } else if (res.status === "ended") {
        ended(res);
    } else if (res.status === "reconnecting") {
        reconnecting(res);
    } else if (res.status === "userstatus") {
        remoteStream = removeDuplicates(remoteStream)
        userStatus(res);
    } else if (res.status === "hold") {
        hold(res);
    }
}

const ringing = (res) => {
    const {
        data = {}
    } = store.getState().showConfrenceData;
    
    if (!onCall && !data.showCalleComponent) {
        const callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt("call_connection_status"));
        if (callConnectionData.callType === "audio") {
            localVideoMuted = true;
        }
        store.dispatch(addShowConfrenceData({
            callStatusText: 'Ringing',
            showStreamingComponent: false,
            localStream,
            remoteStream,
            localVideoMuted,
            localAudioMuted,
            showComponent: true,
        }));
    } else {
        const index = remoteStream.findIndex(item => item.fromJid === res.userJid);
        if (index > -1) {
            const mapRemoteStream = remoteStream.map((ele,ind)=>{
                if(ind === index){
                    return {...ele,status: res.status }
                }else{
                    return{...ele}
                }
            })
            remoteStream = mapRemoteStream
            /**
             remoteStream[index] = {
                 ...remoteStream[index],
                 status: res.status
             };
             */
            
            store.dispatch(addShowConfrenceData({
                ...(data || {}),
                remoteStream: remoteStream
            }));
        }
    }
}

const connecting = (res) => {
    updatingUserStatusInRemoteStream(res.usersStatus);
    let roomId = getFromLocalStorageAndDecrypt('roomName');
    encryptAndStoreInLocalStorage('callingComponent', false)
    const showConfrenceData = store.getState().showConfrenceData;
    const {
        data
    } = showConfrenceData;
    // If 'data.showStreamingComponent' property value is TRUE means, already call is connected &
    // Streaming data has been shared between users. That's why we check condition here,
    // If 'data.showStreamingComponent' is FALSE, then set the 'CONNECTING' state to display.
    if (data && !data.showStreamingComponent && remoteStream.length === 0) {
        remoteStream = [];
        encryptAndStoreInLocalStorage("connecting", true);
        store.dispatch(addShowConfrenceData({
            showComponent: true,
            showStreamingComponent: false,
            showCallingComponent: false
        }))
        callLogs.update(roomId, {
            "sessionStatus": res.sessionStatus,
            // "startTime": callLogs.initTime()
        });
    }
}


const updatingUserStatusInRemoteStream = (usersStatus) => {
    usersStatus.map((user) => {
        const index = remoteStream.findIndex(item => item.fromJid === user.userJid);
        if (index > -1) {
            const mapRemoteStreamupdate = remoteStream.map((ele,ind)=>{
              if(ind === index){
                return {
                    ...ele,
                status: user.status
                }
              }else{
                  return {...ele}
              }
            })
            remoteStream = mapRemoteStreamupdate
            /**
            // remoteStream[index] = {
            //     ...remoteStream[index],
            //     status: user.status
            // };
             */
            newRemoteVideoMuted = constructMute(newRemoteVideoMuted,user.userJid,user.videoMuted)
            newRemoteAudioMuted = constructMute(newRemoteAudioMuted,user.userJid,user.audioMuted)
        } else {
            let streamObject = {
                id: uuidv4(),
                fromJid: user.userJid,
                status: user.status || CONNECTION_STATE_CONNECTING
            }
            remoteStream = [ ...remoteStream,streamObject ]
            newRemoteVideoMuted = constructMute(newRemoteVideoMuted,user.userJid,user.videoMuted)
            newRemoteAudioMuted = constructMute(newRemoteAudioMuted,user.userJid,user.audioMuted)
        }
    });
}

const connected = (res) => {
    /**
    // let localUserStatus = res?.usersStatus.map(ele=>{
    //         if(ele.status !== "CONNECTED"){
    //             return{ ...ele,status:"CONNECTED"}
    //         }else{ return {...ele} }      
    //     })
     */
    let roomId = getFromLocalStorageAndDecrypt('roomName');
    const userIndex = remoteStream.findIndex(item => item.fromJid === res.userJid);
    if (userIndex > -1) {
        let usersStatus = res?.usersStatus;
        updatingUserStatusInRemoteStream(usersStatus);
        updateCallConnectionStatus(usersStatus);
        const {
            getState,
            dispatch
        } = store;
        const showConfrenceData = getState().showConfrenceData;
        const {
            data
        } = showConfrenceData;
        let showComponent = !!data.showComponent;
        let showStreamingComponent = !!data.showStreamingComponent;
        if (!showStreamingComponent && !res.localUser) {
            deleteItemFromLocalStorage('connecting');
            showComponent = false;
            showStreamingComponent = true;
        }
        const connectedStatus = res?.usersStatus?.filter((userCallStatus)=>{
            return userCallStatus.status === "CONNECTED"
        })
        if(!res.localUser && connectedStatus.length === 2){
            callLogs.update(roomId, {
                "startTime": callLogs.initTime(),
                "sessionStatus": res.sessionStatus
            });
        }
        dispatch(addShowConfrenceData({
            ...(data || {}),
            showComponent,
            showStreamingComponent,
            remoteStream,
            status: res.callStatus,
            // callStatusText: CALL_STATUS_CONNECTED,
            localVideoMuted: localVideoMuted,
            localAudioMuted: localAudioMuted,
            remoteVideoMuted: newRemoteVideoMuted,
            remoteAudioMuted: newRemoteAudioMuted
        }));
    }
}


const updateCallConnectionStatus = (usersStatus) => {
    const callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt("call_connection_status"));
    let usersLen;
    if (usersStatus.length) {
        let currentUsers = usersStatus.filter(el => el.status.toLowerCase() !== CALL_STATUS_ENDED);
        usersLen = currentUsers.length;
    }
    let callDetailsObj = {
        ...callConnectionData,
        callMode: ((callConnectionData?.groupId && callConnectionData?.groupId !== null && callConnectionData?.groupId !== "") || usersLen > 2) ? "onetomany" : "onetoone"
    }
    encryptAndStoreInLocalStorage("call_connection_status", JSON.stringify(callDetailsObj));
}

const removingRemoteStream = (res) => {
    let modifiedRemoteStream = [...remoteStream]
    remoteStream.forEach((item, key) => {
        if (item.fromJid === res.userJid) {
            modifiedRemoteStream.splice(key, 1);
        }
    });
    remoteStream = [...modifiedRemoteStream]
}

const handleEngagedOrBusyStatus = (res) => {
    let roomId = getFromLocalStorageAndDecrypt('roomName');
    updatingUserStatusInRemoteStream(res.usersStatus);
    if (res.sessionStatus === "closed") {
        callLogs.update(roomId, {
            "endTime": callLogs.initTime(),
            "sessionStatus": res.sessionStatus
        });
        const callStatusMsg = res.status === "engaged" ? CALL_ENGAGED_STATUS_MESSAGE : CALL_BUSY_STATUS_MESSAGE;
        dispatchDisconnected(callStatusMsg);
        setTimeout(() => {
            localstoreCommon();
            dispatchCommon();
        }, DISCONNECTED_SCREEN_DURATION);
    } else {
        if (remoteStream && Array.isArray(remoteStream) && remoteStream.length < 1) {
            return;
        }
        const {
            getState
        } = store;
        const showConfrenceData = getState().showConfrenceData;
        const {
            data
        } = showConfrenceData;
        if (!onCall) {
            let callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'))
            let userList = callConnectionData.userList.split(",");
            let updatedUserList = [];
            userList.forEach(user => {
                if (user !== res.userJid) {
                    updatedUserList.push(user);
                }
            });
            callConnectionData.userList = updatedUserList.join(",");
            if (callConnectionData.callMode === "onetomany" && !callConnectionData.groupId) {
                if (updatedUserList.length > 1) {
                    callConnectionData.callMode = "onetomany";
                } else {
                    callConnectionData.callMode = "onetoone";
                    callConnectionData.to = updatedUserList[0];
                }
            }
            encryptAndStoreInLocalStorage("call_connection_status", JSON.stringify(callConnectionData));
            store.dispatch(addCallConnectionDate(callConnectionData));
        }
        let userDetails = getUserDetails(res.userJid);
        let toastMessage = res.status === "engaged" ? `${userDetails.displayName} is on another call` : `${userDetails.displayName} is busy`;
        toast.error(toastMessage);
        removingRemoteStream(res);
        /**
        // if (data.showStreamingComponent) {
        //     resetPinAndLargeVideoUser(res.userJid);
        // }
         */
        store.dispatch(addShowConfrenceData({
            ...(data || {}),
            remoteStream: remoteStream,
            remoteVideoMuted:newRemoteVideoMuted,
            remoteAudioMuted:newRemoteAudioMuted
        }));
    }
}

const disconnected = (res) => {
    let roomId = getFromLocalStorageAndDecrypt('roomName');
    let vcardData = getLocalUserDetails();
    let currentUser = vcardData.fromUser;
    currentUser = formatUserIdToJid(currentUser);
    updatingUserStatusInRemoteStream(res.usersStatus);
    let disconnectedUser = res.userJid;
    disconnectedUser = disconnectedUser.includes("@") ? disconnectedUser.split('@')[0] : disconnectedUser;
    if (remoteStream.length < 1 || disconnectedUser === currentUser) {
        deleteItemFromLocalStorage('roomName');
        deleteItemFromLocalStorage('callType');
        deleteItemFromLocalStorage('call_connection_status');
        callLogs.update(roomId, {
            "endTime": callLogs.initTime(),
            "sessionStatus": res.sessionStatus
        });
        store.dispatch(addShowConfrenceData({
            showComponent: false,
            showStreamingComponent: false,
            showCalleComponent: false
        }));
        /**
        // resetPinAndLargeVideoUser();
         */
        store.dispatch(hideModal());
        resetCallData();
    } else {
        store.dispatch(addShowConfrenceData({
            showComponent: false,
            showStreamingComponent: true,
            showCallingComponent: false,
            localStream: localStream,
            remoteStream: remoteStream,
            fromJid: "",
            status: "REMOTESTREAM",
            localVideoMuted: localVideoMuted,
            localAudioMuted: localAudioMuted,
            remoteVideoMuted:newRemoteVideoMuted,
            remoteAudioMuted:newRemoteAudioMuted
        }))
        /**
        // resetPinAndLargeVideoUser(res.fromJid);
         */
        removingRemoteStream(res);
    }
}

const ended = (res) => {
    let roomId = getFromLocalStorageAndDecrypt('roomName');
    if (res.sessionStatus === "closed") {
        let callConnectionData = null;
        if (remoteStream && !onCall && !res.carbonAttended) {
            // Call ended before attend
            callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'));
        }
        callLogs.update(roomId, {
            "endTime": callLogs.initTime(),
            "sessionStatus": res.sessionStatus
        });
        dispatchDisconnected();
        if (callConnectionData) {
            clearMissedCallNotificationTimer();
        }
        setTimeout(() => {
            localstoreCommon();
            store.dispatch(addShowConfrenceData({
                showComponent: false,
                showStreamingComponent: false,
                showCalleComponent: false,
                callStatusText: null
            }))
            store.dispatch(addCallConversion());
            store.dispatch(hideModal());
            store.dispatch(addCallConnectionDate(res));
            store.dispatch(addCallConnectionDate(res));
            // store.dispatch(resetAudioMute())
            if (callConnectionData) {
                const callDetailObj = callConnectionData ? {
                    ...callConnectionData
                } : {};
                callDetailObj['status'] = "ended";
                browserNotify.sendCallNotification(callDetailObj);
            }
            resetCallData();
        }, DISCONNECTED_SCREEN_DURATION);
    } else {
        if (!onCall || (remoteStream && Array.isArray(remoteStream) && remoteStream.length < 1)) {
            return;
        }
        removingRemoteStream(res);
        /**
        // resetPinAndLargeVideoUser(res.userJid);
         */
        updateCallConnectionStatus(res.usersStatus);
        const {
            getState
        } = store;
        const showConfrenceData = getState().showConfrenceData;
        const {
            data
        } = showConfrenceData;
        store.dispatch(addShowConfrenceData({
            ...(data || {}),
            remoteStream: remoteStream,
            remoteVideoMuted:newRemoteVideoMuted,
            remoteAudioMuted:newRemoteAudioMuted
        }));
    }
    
}

const reconnecting = (res) => {
    store.dispatch(addCallConversion())
    updatingUserStatusInRemoteStream(res.usersStatus);
    const {
        getState
    } = store;
    const showConfrenceData = getState().showConfrenceData;
    const {
        data
    } = showConfrenceData;
    store.dispatch(addShowConfrenceData({
        showCallingComponent: false,
        ...(data || {}),
        localStream: localStream,
        remoteStream: remoteStream,
        fromJid: res.userJid,
        status: "REMOTESTREAM",
        localVideoMuted: localVideoMuted,
        localAudioMuted: localAudioMuted,
        remoteVideoMuted:newRemoteVideoMuted,
        remoteAudioMuted:newRemoteAudioMuted,
        callStatusText: CALL_STATUS_RECONNECT,
    }))
}

const userStatus = (res) => {
    updatingUserStatusInRemoteStream(res.usersStatus);
}

const hold = (res) => {
    updatingUserStatusInRemoteStream(res.usersStatus);
    const {
        getState
    } = store;
    const showConfrenceData = getState().showConfrenceData;
    const {
        data
    } = showConfrenceData;
    store.dispatch(addShowConfrenceData({
        showCallingComponent: false,
        ...(data || {}),
        localStream: localStream,
        remoteStream: remoteStream,
        fromJid: res.userJid,
        status: "REMOTESTREAM",
        localVideoMuted: localVideoMuted,
        localAudioMuted: localAudioMuted,
        remoteVideoMuted:newRemoteVideoMuted,
        remoteAudioMuted:newRemoteAudioMuted,
        callStatusText: CALL_STATUS_HOLD,
    }))
}
    /**
    // export const resetPinAndLargeVideoUser=(fromJid)=>{
    //     if (!fromJid) {
    //         store.dispatch(selectLargeVideoUser());
    //         store.dispatch(pinUser());
    //     }
    //     const state = store.getState();
    //     const largeVideoUserData = state.largeVideoUserData;
    //     if (largeVideoUserData.userJid === fromJid) {
    //         store.dispatch(selectLargeVideoUser());
    //     }
    //     // If pinned user disconnected from the call, Need to remove the user.
    //     const pinUserData = state.pinUserData;
    //     if (pinUserData.userJid === fromJid) {
    //         store.dispatch(pinUser(fromJid));
    //     }
    // }
     */
    const speaking = (res) => {
        if (!res.userJid) return;
        /**
        if (!res.localUser) {
            // store.dispatch(selectLargeVideoUser(res.userJid, res.volumeLevel));
        }
         */
    }

    const userName = async() =>{
        const {
            getState
        } = store;
        if(getState().activeChatData.data.length === 0) return;
        const {
            chatId = {},
            chatType
        } = getState().activeChatData.data[0];
        const userJid = formatUserIdToJid(chatId);
        const profileData = await SDK.getUserProfile(userJid)
        if(profileData && profileData.statusCode === 200){
        let response = { 
            email: profileData.data.email,
            image: profileData.data.image,
            isAdminBlocked: 0,
            isDeletedUser: false,
            isFriend: true,
            mobileNumber: profileData.data.mobileNumber,
            name: profileData.nickName,
            nickName: profileData.data.nickName,
            status: profileData.data.status,
            userColor: "",
            userId: profileData.data.userId,
            userJid: userJid,
        }
        let activeChatData = {
            chatId:profileData.data.userId,
            chatJid:userJid,
            chatType: "chat",
            roster: response,
            recent: getState().activeChatData.data[0].recent
        }
        if(chatType === "chat"){
        store.dispatch(addActiveChatData(activeChatData))
        } else{
            // store.dispatch(addRosterData([]))
        }
        }
    }
    

export const callbacks = {
    connectionListener: function (response) {
        console.log(response,"connectionListener")
        // store.getState()?.appOnlineStatus?.isAppOnline
        const connStatus = response.status || "";
        console.log('connStatus :>> ', response.status);
        if (connStatus === "CONNECTED") {
            encryptAndStoreInLocalStorage("connection_status", connStatus);
            setConnectionStatus(connStatus)
            store.dispatch(updateconnStatus(connStatus));
            userName()
            handleBlockMethods()
        } else if (connStatus === "DISCONNECTED") {
            reconnect()
            encryptAndStoreInLocalStorage("connection_status", connStatus);
            setConnectionStatus(connStatus)
            store.dispatch(updateconnStatus(connStatus));
            userName();
        }    
    },messageListener: async function (res){
        if(
            res.msgType === "sentMessage" ||
            res.msgType === "carbonSentMessage" ||  
            res.msgType === "receiveMessage" ||
            // res.msgType === "groupProfileUpdated" ||
            res.msgType === "carbonReceiveMessage" ||
            res.msgType === "receiveMessage" ){
            updateMessageUnreadCount(res,store.getState())
            updateRecentChatMessage(res,store.getState())
            updateConversationMessage(res,store.getState())
        }
        if(res.msgType === "carbonSentSeen"){
            updateMessageUnreadCount(res,store.getState())
        }

        if(res.msgType === "groupProfileUpdated"){
            const groupListRes = await SDK.getGroupsList();
            if (groupListRes && groupListRes.statusCode === 200) {
                store.dispatch(addGroupsData(groupListRes.data));
                updateMessageUnreadCount(res,store.getState())
                // updateRecentChatMessage(res,store.getState())
                updateConversationMessage(res,store.getState())
            }
            const recentChatsRes = await SDK.getRecentChats();
            if (recentChatsRes && recentChatsRes.statusCode === 200) {
                store.dispatch(addRecentChat(recentChatsRes.data));
                unreadCountConstruction(recentChatsRes.data)
            }    
        }
        if (res.msgType === "carbonDelivered" || res.msgType === "delivered" || res.msgType === "seen" || res.msgType === "carbonSeen") {
              store.dispatch(updateRecentChatMessageStatus(res)) 
              store.dispatch(UpdateChatConversationHistory(res))  
              store.dispatch(addMessageInfoUpdate(
                {
                id: uuidv4(),
                activeUserId: res.publisherId,
                time: res.timestamp,
                messageStatus: 
                res.msgType === MSG_DELIVERED_STATUS_CARBON || res.msgType === MSG_DELIVERED_STATUS
                    ? MSG_DELIVERED_STATUS_ID
                    : MSG_SEEN_STATUS_ID
                }))
        }
        if (res.msgType === "acknowledge" && res.type === "acknowledge") {
            store.dispatch(updateRecentChatMessageStatus(res))
            store.dispatch(UpdateChatConversationHistory(res))
        }
        if (res.msgType === "composing"|| res.msgType === "carbonComposing" || res.msgType === "gone" || res.msgType === "carbonGone"  ){
            typingStatus(res)
        }
        if (!res.msgType || res.msgType === "carbonReceiveAcknowledge" || res.msgType === "carbonSentAcknowledge") {
            return;
        }
        if (res.msgType === MSG_DELETE_STATUS || res.msgType === MSG_DELETE_STATUS_CARBON || res.msgType === "carbonMessageClear" ||
            res.msgType === "messageClear" ||
            res.msgType === "clear_message" ) {
            store.dispatch(deleteMessageForMe(res))
            store.dispatch(recentRemoveMessageUpdate(res))
            
            if ((res.msgType === MSG_DELETE_STATUS || res.msgType === MSG_DELETE_STATUS_CARBON) && res.lastMsgId) {
                SDK.getMessageById(res.lastMsgId);
            }
        }

        if (res.msgType === "recallMessage" || res.msgType === "carbonRecallMessage" ||res.msgType === "carbonSentRecall"
            || res.msgType === "carbonReceiveRecall" || (res.msgType === "acknowledge" && res.type === "recall")) 
        {
            store.dispatch(deleteMessageForEveryone(res))
            store.dispatch(recentRecallUpdate(res))
            store.dispatch(messageData(res))
        }

        if (res.msgType === "userBlockStatus" || res.msgType === "carbonUserBlockStatus") {
            store.dispatch(updateContactWhoBlockedMeAction(res.blockedUserId, res.type));
        }

        if (res.msgType === MSG_CLEAR_CHAT || res.msgType === MSG_CLEAR_CHAT_CARBON) {
            store.dispatch(clearLastMessageinRecentChat(res.fromUserId));
            store.dispatch(clearChatHistoryAction(res.fromUserId));
            /**
            // store.dispatch(RemoveStaredMessagesClearChat(res));
             */
        } 
        if (res.msgType === MSG_DELETE_CHAT || res.msgType === MSG_DELETE_CHAT_CARBON) {
            /**
            // const archivedChats = getArchivedChats();
            // if (archivedChats.includes(res.fromUserId)) {
            //     SDK.updateArchiveChat(formatUserIdToJid(res.fromUserId, res.chatType), false);
            // }
             */
            // // Delete the user from recent chat list
            store.dispatch(deleteMessageinRecentChat(res));
            store.dispatch(deleteChatHistoryAction(res));
            const chatId = getActiveConversationChatId();
            if (res.fromUserId === chatId) store.dispatch(resetActiveChatData());
            // // Store.dispatch(RemoveStaredMessagesDeleteChat(res));
        }     
    },userProfileListener: function (res){
        let authUser = getFromLocalStorageAndDecrypt('auth_user');
        store.dispatch(rosterUpdate(res))
        if (authUser.username === res.userId) {
            store.dispatch(addVCardData(res));
        }else {
            // updateVCardData(res)
            store.dispatch(rosterUpdate(res))
        }
    },presenceListener : function (res){
        store.dispatch(addPresenceData(res))
    },mediaUploadListener: function (res){
        store.dispatch(updateMediaUploadStateData(res));
    },replyMessageListener: function (res){
        store.dispatch(addReplyMessageData(res));
    },groupMsgInfoListener: function (res){
        // store.dispatch(addMessageInfoData(res))
        messageInfoAction(res)
    },blockUserListener: function (res) {
        store.dispatch(updateBlockedContactAction(res.blockedUserId, res.type));
    },singleMessageDataListener: function (res) {
        store.dispatch(updateRecentMsgByLastMsgId(res));
    },muteChatListener: function (res) {
        if (res?.type === "carbon") {
            store.dispatch(updateMuteStatusRecentChat(res));
            store.dispatch(updateMuteStatusActiveChat(res));
        }
    },groupProfileListener: async function (res){
        if (res.groupJid) {
            store.dispatch(updateGroupsData(res));
            const groupData = getGroupData(res.groupJid);
            const groupPartRes = await SDK.getGroupParticipants(res.groupJid);
            if (groupPartRes && groupPartRes.statusCode === 200) {
                setGroupParticipantsByGroupId(res.groupJid, groupPartRes.data.participants);
            }
            // // handleTempArchivedChats(res.groupJid, CHAT_TYPE_GROUP);
            if (groupData && isActiveConversationUserOrGroup(res.groupJid)) {
                // Fetch the group participants details
                if (
                    [
                        GROUP_USER_ADDED,
                        GROUP_USER_REMOVED,
                        GROUP_USER_MADE_ADMIN,
                        GROUP_PROFILE_INFO_UPDATED,
                        GROUP_USER_LEFT
                    ].indexOf(res.msgType) > -1
                ) {
                    if (groupPartRes && groupPartRes.statusCode === 200) {
                        setGroupParticipants(groupPartRes.data);
                    }
                }
            } 
            // else {
            //     if (res.msgType === GROUP_USER_ADDED) {
            //         const groupListRes = await SDK.getGroupsList();
            //         if (groupListRes && groupListRes.statusCode === 200) {
            //             store.dispatch(addGroupsData(groupListRes.data));
            //         }
            //         const recentChatsRes = await SDK.getRecentChats();
            //         if (recentChatsRes && recentChatsRes.statusCode === 200) {
            //             store.dispatch(addRecentChat(recentChatsRes.data));
            //             // unreadCountConstruction(recentChatsRes.data)
            //         }
            //     }
            // }
            // store.dispatch(updateGroupsData(res));
        }
    },incomingCallListener: function (res){
        strophe = true;
        remoteStream = [];
        localStream = null;
        let callMode = "onetoone";
        if (res.toUsers.length === 1 && res.groupId === null) {
            res.from = res.toUsers[0];
            res.to = res.userJid;
            if (res.callType === "audio") {
                localVideoMuted = true;
            }
        } else {
            callMode = "onetomany";
            res.from = res.userJid;
            res.to = res.groupId ? res.groupId : res.userJid;
            res.userList = res.allUsers.join(",");
            if (res.callType === "audio") {
                localVideoMuted = true;
            }
        }
        res.callMode = callMode;
        encryptAndStoreInLocalStorage("call_connection_status", JSON.stringify(res));
        let roomId = getFromLocalStorageAndDecrypt('roomName');
        if (roomId === "" || roomId === null || roomId === undefined) {
            // // resetPinAndLargeVideoUser();
            encryptAndStoreInLocalStorage('roomName', res.roomId);
            encryptAndStoreInLocalStorage('callType', res.callType)
            encryptAndStoreInLocalStorage('callFrom', res.from);
            if (res.callType === "audio") {
                localVideoMuted = true;
            }
            store.dispatch(addCallConnectionDate(res));
            store.dispatch(addShowConfrenceData({
                showComponent: false,
                showStreamingComponent: false,
                showCalleComponent: true
            }));
            updatingUserStatusInRemoteStream(res.usersStatus);
            browserNotify.sendCallNotification(res);
            // // startMissedCallNotificationTimer();
        } else {
            console.log("callEngaged")
            SDK.callEngaged();
        }
        callLogs.insert({
            "callMode": res.callMode,
            "callState": 0,
            "callTime": callLogs.initTime(),
            "callType": res.callType,
            "fromUser": res.from,
            "roomId": res.roomId,
            "userList": res.userList || res.to,
            "groupId": res.callMode === "onetoone" ? '' : res.groupId
        });
        startCallingTimer();
    },callStatusListener: function (res){
        callStatus(res);
    },userTrackListener: (res,check) => {
        if (res.localUser) {
            if (!res.trackType) {
                return;
            }
            localStream = localStream || {};
            let mediaStream = null;
            if (res.track) {
                mediaStream = new MediaStream();
                mediaStream.addTrack(res.track);
            }
            let  localStreamLocal = {...localStream}
            localStreamLocal[res.trackType] = mediaStream;
            localStream = {...localStreamLocal}
            const {
                getState,
                dispatch
            } = store;
            const showConfrenceData = getState().showConfrenceData;
            const {
                data
            } = showConfrenceData;
            const usersStatus = res.usersStatus;
            usersStatus.map((user) => {
                const index = remoteStream.findIndex(item => item.fromJid === user.userJid);
                if (index > -1) {

                const mapRemoteStreamSucc =  remoteStream.map((ele,ind)=>{
                        if(ind === index){
                            return { ...ele,'status' : user.status }
                        }else{
                            return {...ele}
                        }
                    })
                    remoteStream = mapRemoteStreamSucc
                    newRemoteVideoMuted = constructMute(newRemoteVideoMuted,user.userJid,user.videoMuted)
                    newRemoteAudioMuted = constructMute(newRemoteAudioMuted,user.userJid,user.audioMuted)
                } else {
                    let streamObject = {
                        id: uuidv4(),
                        fromJid: user.userJid,
                        status: user.status,
                    }
                    // // remoteStream.push(streamObject);
                    remoteStream = [ ...remoteStream,streamObject ]
                    newRemoteVideoMuted = constructMute(newRemoteVideoMuted,user.userJid,user.videoMuted)
                    newRemoteAudioMuted = constructMute(newRemoteAudioMuted,user.userJid,user.audioMuted)
                }
            });
            const roomName = getFromLocalStorageAndDecrypt('roomName');
            if (roomName === "" || roomName == null || roomName == undefined) { 
                const { roomId = "" } = SDK.getCallInfo();
                const call = SDK.getCallInfo();
                console.log("callcallcallcall",call)
                console.log('localStorage roomId :>> ', roomId,check);
                encryptAndStoreInLocalStorage('roomName', roomId);
            }
            dispatch(addShowConfrenceData({
                localVideoMuted: localVideoMuted,
                ...(data || {}),
                localStream: localStream,
                remoteStream,
                localAudioMuted: localAudioMuted,
                status: "LOCALSTREAM"
            }));
        } else {
            onCall = true;
            encryptAndStoreInLocalStorage('callingComponent', false);
            const streamType = res.trackType;
            let mediaStream = null;
            if (res.track) {
                mediaStream = new MediaStream();
                mediaStream.addTrack(res.track);
            }
            const streamUniqueId = `stream${streamType.charAt(0).toUpperCase() + streamType.slice(1)}Id`;
            updatingUserStatusInRemoteStream(res.usersStatus);
            const userIndex = remoteStream.findIndex(item => item.fromJid === res.userJid);
            if (userIndex > -1) {
                let {
                    stream
                } = remoteStream[userIndex];
                stream = {...stream} || {};
                stream[streamType] = mediaStream;
                stream['id'] = uuidv4();
                stream[streamUniqueId] = uuidv4();
                const mapRemote = remoteStream.map((ele,ind)=>{
                    if(ind === userIndex){
                        return { ...ele,'stream' : stream }
                    }else{
                        return {...ele}
                    }
                })
                remoteStream = mapRemote;
            } else {
                let streamObject = {
                    id: uuidv4(),
                    fromJid: res.userJid,
                    status: CALL_STATUS_CONNECTED,
                    stream: {
                        [streamUniqueId]: uuidv4(),
                        [streamType]: mediaStream
                    }
                }
                // // remoteStream.push(streamObject);
                remoteStream = [ ...remoteStream,streamObject ]                
            }

            // When remoteStream user length is one, set that user as large video user
            if (remoteStream.length === 2) {
                store.dispatch(largeVideoUserReducer(res.userJid));
            } else {
                remoteStream.forEach((item) => {
                    return store.dispatch(largeVideoUserReducer(item.userJid));
                });
            }

            const {
                showConfrenceData,
                callConversionData
            } = store.getState();
            const {
                data
            } = showConfrenceData;
            store.dispatch(addShowConfrenceData({
                showCallingComponent: false,
                localVideoMuted: localVideoMuted,
                ...(data || {}),
                localStream: localStream,
                remoteStream: remoteStream,
                fromJid: res.userJid,
                status: "REMOTESTREAM",
                localAudioMuted: localAudioMuted,
                remoteVideoMuted:newRemoteVideoMuted,
                remoteAudioMuted:newRemoteAudioMuted,
                callStatusText: CALL_STATUS_CONNECTED
            }))

            // Need to hide the call converison request & response screen when more than one remote
            // users joined in call
            if (remoteStream.length >= 3) {
                const status = callConversionData && callConversionData.status === CALL_CONVERSION_STATUS_REQ_WAITING ? {
                    status: CALL_CONVERSION_STATUS_CANCEL
                } : undefined;
                store.dispatch(addCallConnectionDate(status));
                status && SDK.callConversion(CALL_CONVERSION_STATUS_CANCEL);
            }
        }
    },mediaErrorListener: (res) => {
        if (res.action === "subscribeCall" && res.statusCode === 100607) {
            muteLocalVideo(true);
            const {
                getState
            } = store;
            const showConfrenceData = getState().showConfrenceData;
            const {
                data
            } = showConfrenceData;
            store.dispatch(addShowConfrenceData({
                ...(data || {}),
                mediaError: true,
                localVideoMuted: true
            }));
        }
        store.dispatch(showModal({
            open: true,
            modelType: res.callStatus === "MEDIA_PERMISSION_DENIED" ? 'mediaPermissionDenied' : 'mediaAccessError',
            ...res
        }));
    },callSpeakingListener: (res) => {
        speaking(res);
    }, callUsersUpdateListener: (res) => {
        remoteStream.forEach((item) => {
            if (!res.usersList.includes(item.fromJid)) {
                removeRemoteStream(item.fromJid);
            }
        });
        
        store.dispatch(addCallIntermediate({
            usersList: res.usersList
        }));

        subscribed(res);
    },helper:{
        getDisplayName: () => {
            let vcardData = getLocalUserDetails();
            if (vcardData.nickName) {
                return vcardData.nickName;
            }
            return "Anonymous user " + Math.floor(Math.random() * 10);
        },
        getImageUrl: () => {
            let vcardData = getLocalUserDetails();
            if (vcardData) {
                return vcardData.image;
            }
            return "";
        }
    },
    inviteUsersListener: (res) => {
        updatingUserStatusInRemoteStream(res.usersStatus);
        const showConfrenceData = store.getState().showConfrenceData;
        const {
            data
        } = showConfrenceData;
        store.dispatch(addShowConfrenceData({
            ...(data || {}),
            status: "REMOTESTREAM",
            remoteStream: remoteStream
        }));
        callLogs.update(res.roomId, {
            "userList": res.userList
        });
        startCallingTimer();
    },
    callUserJoinedListener: function (res) {
        if (res.userJid && !res.localUser) {
            updateStoreRemoteStream();
            handleCallParticipantToast(res.userJid, "join");
        }
    },
    callUserLeftListener: function (res) {
        if (res.userJid && !res.localUser) {
            updateStoreRemoteStream();
            handleCallParticipantToast(res.userJid, "left");
        }
    },missedCallListener: (res) => {
        if(res.status === "ended"){
            let roomId = getFromLocalStorageAndDecrypt('roomName');
            callLogs.update(roomId,{
                    "callState": 0,
            });
        }
        /**
        // callLogs.insert({
        //     "callMode": res.callMode,
        //     "callState": 0,
        //     "callTime": callLogs.initTime(),
        //     "callType": res.callType,
        //     "fromUser": res.from,
        //     "roomId": res.roomId,
        //     "userList": res.allUsers,
        //     "groupId": res.groupId
        // });
         */
    },
    callSwitchListener: function (res) {
        if(res.status === CALL_CONVERSION_STATUS_DECLINE){
            toast.error("Request declined")
        }
        store.dispatch(addCallConversion({
            status: res.status,
            fromUser: res.userJid
        }));
    },
    muteStatusListener: (res) => {
        if (!res) return;
        let localUser = false;
        let vcardData = getLocalUserDetails();
        const currentUser = vcardData.fromUser;
        let mutedUser = res.userJid;
        mutedUser = mutedUser.includes("@") ? mutedUser.split('@')[0] : mutedUser;
        if (res.localUser || currentUser === mutedUser) {
            localUser = true;
        }
        if (localUser) {
            if (res.trackType === CALL_TYPE_AUDIO) {
                localAudioMuted = res.isMuted;
            }
            if (res.trackType === CALL_TYPE_VIDEO) {
                localVideoMuted = res.isMuted;
            }
        } else {
            if (res.trackType === CALL_TYPE_AUDIO) {
                newRemoteAudioMuted = constructMute(newRemoteAudioMuted,res.userJid,res.isMuted)
                if (res.isMuted) {
                    // // store.dispatch(selectLargeVideoUser(res.userJid, -100));
                }
            }
            if (res.trackType === CALL_TYPE_VIDEO) {

                newRemoteVideoMuted = constructMute(newRemoteVideoMuted,res.userJid,res.isMuted)

                // // remoteVideoMuted[res.userJid] = res.isMuted;
            }
        }
        const showConfrenceData = store.getState().showConfrenceData;
        const {
            data
        } = showConfrenceData;
        let showComponent = data.showComponent;
        let showStreamingComponent = data.showStreamingComponent;
        let showCallingComponent = data.showCallingComponent;
        let showCalleComponent = data.showCalleComponent;
        store.dispatch(addShowConfrenceData({
            ...data,
            showComponent: showComponent,
            showStreamingComponent: showStreamingComponent,
            showCallingComponent: showCallingComponent,
            showCalleComponent: showCalleComponent,
            localStream: localStream,
            remoteStream: remoteStream,
            fromJid: res.userJid,
            status: "MUTESTATUS",
            localVideoMuted: localVideoMuted,
            localAudioMuted: localAudioMuted,
            remoteVideoMuted:newRemoteVideoMuted,
            remoteAudioMuted:newRemoteAudioMuted
        }))
        updateCallTypeAfterCallSwitch();
    },
    adminBlockListener: function (res) {
        /**
        // store.dispatch(addRosterData([]))
        // store.dispatch(vcardUpdate({
        //     userId: res.toUserId,
        //     isAdminBlocked: res.blockStatus === "1"
        // }));

        // store.dispatch(addAdminBlock(res));

        // logout("adminBlock")
        // const callConnectionGroupJid = null;
        // if (onCall) {
        //     callConnectionGroupJid = store.getState()?.callConnectionDate?.data?.groupId
        // }
         */
        if (isLocalUser(res.toUserId)) {
            if (res.blockStatus === "1") {
                store.dispatch(addAdminBlock(res));
                // // store.dispatch(adminBlockStatusUpdate(res));
                SDK.endCall();
                resetCallData();
                // // stopRecorder();
                logout("block");
            }
        } else if (isSingleChatJID(res.toUserJid)) {
            /**
            // if (isActiveConversationUserOrGroup(res.toUserId) && res.blockStatus === "1") {
            //     stopRecorder();
            // }
             */
            store.dispatch(rosterUpdate({
                userId: res.toUserId,
                isAdminBlocked: res.blockStatus === "1"
            }));
        } else {
            if (isActiveConversationUserOrGroup(res.toUserId)) {
                if(res.blockStatus === "1"){
                    toast.info("This group is no longer available")
                    /**
                    // Store.dispatch(messageForwardReset());
                    // Store.dispatch(ActiveChatResetAction());
                    // stopRecorder();
                    
                    // Store.dispatch(hideModal())
                    // if(callConnectionGroupJid === res.toUserJid){
                    //     disconnectCallConnection()
                    // }
                     */
                }
            }
            // else if(callConnectionGroupJid === res.toUserJid && res.blockStatus === "1"){
            //             disconnectCallConnection()
            // }
            // Store.dispatch(GroupDataUpdateAction({
            //     groupJid: res.toUserJid,
            //     isAdminBlocked: res.blockStatus === "1"
            // }));
        }
    },
}


